import React, { useState, useEffect } from "react";
import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  TextField,
  Autocomplete,
  Button,
  Box,
  Accordion,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UseProduct } from "./UseProduct";
import ModelAutoComplete from "../../basic-information/productModel/ModelAutoComplete";
import TargetAutoComplete from "../../basic-information/productTarget/TargetAutoComplete";
import { useSnackbar } from "notistack";
import PUsageAutoComplete from "../../basic-information/productUsage/PUsageAutoComplete";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Level3(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { validateLvl3Edit } = UseProduct();
  const { isSmall } = useBreakpoints();

  const [level3, setLevel3] = React.useState({
    registerCode: "",
    gender: null,
    spf: "",
    modelID: "",
    targetLocationID: "",
    appropriateID: "",
  });

  const [stateValidation, setStateValidation] = useState({
    gender: false,
  });

  const options = [
    { label: "عمومی", id: "0" },
    { label: "آقایان", id: "1" },
    { label: "بانوان", id: "2" },
  ];

  useEffect(() => {
    if (props.fireGetData) {
      props.getDataFromLevel3(level3);
    }
  }, [props.fireGetData]);

  return (
    <Accordion
      expanded={props.expanded === "panel3"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography sx={{ width: "33%", flexShrink: 0 }}>مرحله سوم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <Autocomplete
              size="small"
              fullWidth
              options={options && options}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="جنسیت"
                  error={stateValidation.gender}
                />
              )}
              onChange={(event, newValue) => {
                setLevel3({
                  ...level3,
                  gender: newValue.id,
                });
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              size="small"
              fullWidth
              id="outlined-basic"
              value={level3.registerCode}
              label="   پروانه ساخت "
              variant="outlined"
              onChange={(event) => {
                setLevel3({
                  ...level3,
                  registerCode: event.target.value,
                });
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TargetAutoComplete
              setter={setLevel3}
              lvl3State={level3}
            ></TargetAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <ModelAutoComplete
              setter={setLevel3}
              lvl3State={level3}
            ></ModelAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              id="outlined-basic"
              size="small"
              fullWidth
              value={level3.spf}
              label=" spf "
              variant="outlined"
              onChange={(event) => {
                setLevel3({ ...level3, spf: event.target.value });
              }}
              sx={{ width: "100%" }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <PUsageAutoComplete
              selectedUsageID={level3.appropriateID}
              setter={setLevel3}
              lvl3State={level3}
            ></PUsageAutoComplete>
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            size="small"
            onClick={() => {
              props.setExpanded("panel2");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              validateLvl3Edit(level3, setStateValidation, () => {
                enqueueSnackbar("مرحله سوم با موفقیت تکمیل شد", {
                  variant: "success",
                  autoHideDuration: 2000,
                });
                props.setExpanded("panel4");
              });
            }}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
